import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Card, CardHeader, CardContent, List, ListItem, ListItemText, Divider } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    marginBottom: '15px',
  },
  list: {
    // border: "1px solid #EEEEEE"
  }
}));

export default function ProjectList(props) {
  const { source, onCentralSelected, ...rest } = props;
  const classes = useStyles();

  const handleListItemClick = (event, centralID) => {
    onCentralSelected(centralID);
  };

  return (
    <Card
      {...rest}
      className={clsx(classes.root)}
    >
      <CardHeader title="Anlagenauswahl" />
      <CardContent>
        <List className={classes.list} component="nav" aria-label="project list">
          <Divider />
          {source.projects.map((project) => (
            project.centrals.map((central) =>
              (<Fragment key={central.id}>
                <ListItem button onClick={event => handleListItemClick(event, central.id)}>
                  <ListItemText primary={project.name} secondary={central.name} />
                </ListItem>
                <Divider/>
                </Fragment>)
            )))}
        </List>
      </CardContent>
    </Card>
  );
};

ProjectList.propTypes = {
  source: PropTypes.object.isRequired,
  onCentralSelected: PropTypes.func.isRequired,
};